import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { RogTaskInfo, RogDetail, RogDetailInput, RogRetract } from '../models/rog';
import { MyTasks, Task, TaskCount } from '../models/task';
import { WarrantyCreation } from '../models/warranty';
import { PaginatedRequest } from '../models/paginated-request';
import { PaginatedResponse } from '../models/paginated-response';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TasksService {

  baseUrl = environment.tasksServiceBaseUrl;

  public refreshTasksCount = new BehaviorSubject(false);

  constructor(private http: HttpClient) {
  }

  getRogsByProject(projectName: string) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    const url = `${this.baseUrl}receiptofgoods/project/${encodeURIComponent(projectName)}`;
    return this.http.get<RogTaskInfo[]>(url, { headers });
  }

  getRog(accountNumber: string, orderNumber: string) {
    const input = new RogDetailInput();
    input.accountNumber = accountNumber;
    input.orderNumber = orderNumber;

    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    const url = `${this.baseUrl}receiptofgoods`;
    return this.http.post<RogDetail>(url, input, { headers });
  }

  updateRogTask(updatedInput: RogDetailInput) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    const url = `${this.baseUrl}receiptofgoods/update`;
    return this.http.post<RogDetail>(url, updatedInput, { headers });
  }

  sendRogRetractMail(rogRetract: RogRetract) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    const url = `${this.baseUrl}receiptofgoods/rogRetract`;
    return this.http.post<string>(url, rogRetract, { headers });
  }

  getTasksByProject(projectName: string, accountNumber: string) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    const url = `${this.baseUrl}tasks/project/${encodeURIComponent(projectName)}`;
    const params = new HttpParams()
      .set('account_number', accountNumber)
    return this.http.get<Task[]>(url, { params, headers });
  }

  createWarranty(warranty: WarrantyCreation)
  {
    const headers = new HttpHeaders().set('Accept', 'application/json');
    const url = `${this.baseUrl}warranty/create`;
    return this.http.post<string>(url, warranty, {headers});
  }

  getTasksCountByProject(projectId: string, projectName: string, accountNumber: string) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    const url = `${this.baseUrl}tasks/project/count/${encodeURIComponent(projectName)}`;
    const params = new HttpParams()
      .set('account_number', accountNumber)
      .set('projectId', projectId)
      .set('locationCode', localStorage.getItem("marketLocationCode"))
    return this.http.get<TaskCount[]>(url, { params, headers });
  }

  getMyTasks(myTasks: MyTasks, paginatedRequest: PaginatedRequest){
    const url = `${this.baseUrl}tasks/list`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    const params = new HttpParams()
      .set('page', paginatedRequest.page)
      .set('size', paginatedRequest.pageSize)
      .set('sort', paginatedRequest.sorting);
    return this.http.post<PaginatedResponse>(url, myTasks, { params, headers });
  }

  getMyTasksBoolValue(marketId: string){
    const url = `${this.baseUrl}tasks/count/${encodeURIComponent(marketId)}`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.get<any>(url, { headers });
  }

  getTasksByWorksheetId(worksheetId: string) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    const url = `${this.baseUrl}tasks/worksheet/${worksheetId}`;
    return this.http.get<Task[]>(url, { headers });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/services/tasks.service.ts